import React from 'react';
import { Box } from '@mui/material';
import { LAYER_STYLES } from './codingColors';

// A label with the layer it comes from (Figma "Label-layer chip"): original, model, llm,
// annotation, adjudication or final. Model and LLM are dashed purple and belong on researcher
// screens only, never on an annotator, adjudicator or teacher screen.
const LabelLayerChip = ({ layer, code, label }) => {
    const style = LAYER_STYLES[layer] || LAYER_STYLES.original;
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1,
                py: 0.375,
                borderRadius: 999,
                color: style.color,
                bgcolor: style.background,
                border: style.dashed ? `1px dashed ${style.color}` : '1px solid transparent',
                lineHeight: 1.3,
                whiteSpace: 'nowrap',
            }}
        >
            <Box component="span" sx={{ fontSize: '0.6875rem', fontWeight: 500 }}>{label || style.label}</Box>
            {/* code="" shows the layer's name only, as in a column heading */}
            {code !== '' && <Box component="span" sx={{ fontSize: '0.75rem', fontWeight: 700 }}>{code || '—'}</Box>}
        </Box>
    );
};

export default LabelLayerChip;
